import React, { ReactNode } from 'react';
import { ButtonWrapper, Heading, CardWrapper } from './style';
import { Icon } from 'components/Input';
import { CommonButton } from 'components/Buttons';
import utils from 'utils';

export type Icon = 'acquisition' | 'ai' | 'validation' | 'export' | 'workflow' | 'archive';
export interface CTCardProps {
  title: string;
  children: ReactNode;
  icon?: Icon;
  ctaText?: string;
  action: () => void;
}

const CTCard = ({ title, children, icon, action, ctaText }: CTCardProps) => {
  const t = utils.intl.useTranslator();

  return (
    <CardWrapper>
      <Heading>{title}</Heading>
      {children}
      <ButtonWrapper>
        <CommonButton id="see-more-data" useThrottle={false} action={action} value={ctaText || t('seeMoreData')} />
      </ButtonWrapper>
      {icon && (
        <Icon
          icon={icon}
          style={{
            width: '100%',
            opacity: '0.3',
            position: 'absolute',
            right: '-27%',
            bottom: '-27%',
            cursor: 'default',
          }}
        />
      )}
    </CardWrapper>
  );
};

export default CTCard;
